/**
 * Projects exempt from the "budget is locked once tendering starts" rule.
 *
 * Normally, once a project's `tenderProcessInitiated` flag is set, the Input
 * Matrix BUDGET view becomes read-only so budget numbers can no longer drift
 * away from the figures a tender was raised against. Demo projects need to stay
 * fully editable so both flows can be walked through repeatedly.
 *
 * Matched case-insensitively against the trimmed project `name`. Renaming a
 * project silently removes the exemption.
 */
export const BUDGET_TENDER_LOCK_EXEMPT_PROJECT_NAMES = ['The Demo Project'];
